import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    label: 'Home',
    href: '#hero'
  }, {
    label: 'About',
    href: '#about'
  }, {
    label: 'Services',
    href: '#services'
  }, {
    label: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100 transition-shadow duration-300 ${scrolled ? 'shadow-md' : 'shadow-none'}`} data-id="element-128">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-129">
        <div className="flex items-center justify-between h-20" data-id="element-130">
          {/* Logo */}
          <a href="#hero" className="flex items-center flex-shrink-0" data-id="element-131">
            <img src="https://cdn.magicpatterns.com/uploads/wN4KWoun6xQSNGkSCbnNrT/Logo_RR_Group_Consulting_copy.png" alt="RR Group Consulting" className="h-12 w-auto" data-id="element-132" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" aria-label="Main navigation" data-id="element-133">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-[#3C3C3C] font-medium text-sm hover:text-[#3A9A6A] transition-colors duration-200" data-id="element-134">
                {link.label}
              </a>)}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block" data-id="element-135">
            <a href="#contact" className="bg-[#3A9A6A] hover:bg-[#2d7a54] text-white font-semibold rounded-lg px-5 py-2.5 text-sm transition-colors duration-200" data-id="element-136">
              Request Consultation
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-[#3C3C3C]" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle mobile menu" aria-expanded={mobileOpen} data-id="element-137">
            {mobileOpen ? <XIcon size={24} data-id="element-138" /> : <MenuIcon size={24} data-id="element-139" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 space-y-4" data-id="element-140">
          {navLinks.map(link => <a key={link.label} href={link.href} className="block text-[#3C3C3C] font-medium py-2 hover:text-[#3A9A6A] transition-colors" onClick={() => setMobileOpen(false)} data-id="element-141">
              {link.label}
            </a>)}
          <a href="#contact" className="block bg-[#3A9A6A] hover:bg-[#2d7a54] text-white font-semibold rounded-lg px-5 py-3 text-center transition-colors duration-200" onClick={() => setMobileOpen(false)} data-id="element-142">
            Request Consultation
          </a>
        </div>}
    </header>;
}